<template>
  <div class="floating-bar">
    <div class="message-wrapper">
      <Icon
        class="icon"
        size="sm"
        :name="info_icon ? 'general.info' : 'general.stars'"
      />
      <slot name="message">
        <span class="message">Zight AI updated your content <a href="#">below</a>.</span>
      </slot>
    </div>
    <span v-if="trial" class="trial-badge cursor-pointer" @click.prevent="emit('trial-click')">AI Trial</span>
    <button class="close-button" @click.prevent="emit('close')" data-testid="floating-bar-close">
      <Icon size="xs" name="general.cross" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '../icon';

defineProps({
  trial: {
    default: false,
    required: false,
    type: Boolean,
  },
  info_icon: {
    default: false,
    required: false,
    type: Boolean,
  },
});

const emit = defineEmits(['close', 'trial-click']);
</script>

<style scoped>
.floating-bar {
  @apply absolute z-50 top-6 left-1/2 -translate-x-1/2 min-w-max pl-2 pr-1 py-1 flex gap-2 items-center text-sm text-slate-700 border border-[#EBDDE2] rounded-full;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%), linear-gradient(90deg, #f5d9b7 0%, #e0adff 50%, #f5d9b7 100%);
  background-size: 200% 200%;
  animation: animateGlow 1.25s linear infinite;
}
@keyframes animateGlow {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}
.message-wrapper {
  @apply flex items-center gap-1;
}
.icon {
  @apply shrink-0;
}
.message {
  @apply shrink-0;
}
.message a {
  @apply underline;
}
.trial-badge {
  @apply flex shrink-0 py-0.5 px-2 rounded-full text-xs font-bold uppercase text-white bg-gradient-to-r from-[#EB6C57] to-[#E4983E];
}
.close-button {
  @apply p-1 rounded-full hover:bg-zinc-900/10;
}
</style>
